<template>
  <v-layout>
    <v-btn @click="exportExcel" color="#216AA9" style="color: white;">ดาวน์โหลด Excel</v-btn>
  </v-layout>
</template>

<script>
export default {
    methods:{
        exportExcel(){
            this.$emit('message-excel')
        }
    }
};
</script>

<style></style>
